import React from "react";
import RoundtablesAppApi from "../api/roundtablesAppApi";

export default React.createContext<RoundtablesAppApi>(null);
